module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_5-b94102466bb38b604483479c907893d6.png";